
    var riot = require('riot')
    
riot.tag2('registration', '<div if="{!regtype}"> <h3>Select your membership type</h3> <div class="row"> <div each="{member in membertypes}" class="col-xs-12 col-md-4 text-center"> <div onclick="{choosetype}" data-type="member" class="memberblock"> <h4>{member}<br>Membership</h4> </div> </div> </div> </div> <div if="{regtype}"> <h2>{regtype} Membership</h2> <form name="regform" if="{showform}" onsubmit="{register}"> <h4>Personal Information</h4> <div class="row"> <div class="col-xs-12 col-md-6"> <div if="{regtype!=\'student\'}" class="form-group row"> <label class="col-xs-12 col-md-4">Prefix<sup>*</sup></label> <div class="col-xs-12 col-md-8"> <label class="radio-inline"> <input type="radio" name="prefix" value="Mr" required onchange="{handleUpdatePrefix}">Mr. </label> <label class="radio-inline"> <input type="radio" name="prefix" value="Mrs" required onchange="{handleUpdatePrefix}">Mrs. </label> <label class="radio-inline"> <input type="radio" name="prefix" value="Ms" required onchange="{handleUpdatePrefix}">Ms. </label> </div> </div> <div class="form-group row"> <label class="col-xs-12 col-md-4">First name<sup>*</sup></label> <div class="col-xs-12 col-md-8"> <input type="text" id="first_name" name="first_name" value="" required class="form-control"> </div> </div> <div class="form-group row"> <label class="col-xs-12 col-md-4">Last name<sup>*</sup></label> <div class="col-xs-12 col-md-8"> <input type="text" name="surname" value="" required class="form-control"> </div> </div> </div> <div class="col-xs-12 col-md-6"> <div if="{regtype!=\'student\'}" class="form-group row"> <label class="col-xs-12 col-md-4">Title</label> <div class="col-xs-12 col-md-8"> <input type="text" name="title" value="" class="form-control"> </div> </div> <div class="form-group row"> <label class="col-xs-12 col-md-4">Designation</label> <div class="col-xs-12 col-md-8"> <input type="text" name="designation" value="" class="form-control"> </div> </div> <div if="{regtype!=\'student\'}" class="form-group row"> <label class="col-xs-12 col-md-4">Organisation</label> <div class="col-xs-12 col-md-8"> <input type="text" name="organisation" value="" class="form-control"> </div> </div> <div if="{regtype==\'student\'}" class="form-group row"> <label class="col-xs-12 col-md-4">GROUP / School / Institution</label> <div class="col-xs-12 col-md-8"> <select name="school" class="form-control"> <option value="">select</option> <option value="1">École Estienne, Illustration Scientifique - Paris, FR</option> <option value="6">BIOMAB, Biological and Medical Art - Antwerp, BE</option> <option value="7">CFIC Ilustração Científica, Dep. Biologia - Aveiro, PT</option> <option value="4">Hochschule Luzern Design &amp; Kunst - Luzern, CH</option> <option value="8">MAET Medical Artists\' Education Trust - London, UK</option> <option value="2">Master in Scientific Illustration - Maastricht, NL</option> <option value="3">Medical and Forensic Art - Dundee, UK</option> <option value="5">Scientific Visualization - Zurich, CH</option> </select> </div> </div> </div> </div> <hr class="hrleft"> <h4>Address Information</h4> <div class="row"> <div class="col-xs-12 col-md-6"> <div class="form-group row"> <label class="col-xs-12 col-md-4">Work address<sup>*</sup></label> <div class="col-xs-12 col-md-8"> <input type="text" name="address" value="" required class="form-control"> </div> </div> <div class="form-group row"> <label class="col-xs-12 col-md-4">City<sup>*</sup></label> <div class="col-xs-12 col-md-8"> <input type="text" name="city" value="" required class="form-control"> </div> </div> <div class="form-group row"> <label class="col-xs-12 col-md-4">State</label> <div class="col-xs-12 col-md-8"> <input type="text" name="state" value="" class="form-control"> </div> </div> </div> <div class="col-xs-12 col-md-6"> <div class="form-group row"> <label class="col-xs-12 col-md-4">Postal code<sup>*</sup></label> <div class="col-xs-12 col-md-8"> <input type="text" name="postcode" value="" required class="form-control"> </div> </div> <div class="form-group row"> <label class="col-xs-12 col-md-4">Country<sup>*</sup></label> <div class="col-xs-12 col-md-8"> <input type="text" name="country" value="" required class="form-control"> </div> </div> </div> </div> <hr class="hrleft"> <h4>Phone, Fax, Web Information</h4> <div class="row"> <div class="col-xs-12 col-md-6"> <div class="form-group row"> <label class="col-xs-12 col-md-4">Work phone</label> <div class="col-xs-12 col-md-8"> <input type="text" name="phone1" value="" class="form-control"> </div> </div> <div if="{regtype!=\'student\'}" class="form-group row"> <label class="col-xs-12 col-md-4">Mobile phone</label> <div class="col-xs-12 col-md-8"> <input type="text" name="phone2" value="" class="form-control"> </div> </div> <div class="form-group row"> <label class="col-xs-12 col-md-4">Fax</label> <div class="col-xs-12 col-md-8"> <input type="text" name="fax" value="" class="form-control"> </div> </div> </div> <div class="col-xs-12 col-md-6"> <div class="form-group row"> <label class="col-xs-12 col-md-4">Email<sup>*</sup></label> <div class="col-xs-12 col-md-8"> <input type="text" name="email" value="" onblur="{checkemail}" required class="form-control"> <div if="{emailerror}" class="error emailerror">Sorry, that email is already registered with Aeims</div> </div> </div> <div if="{regtype!=\'student\'}" class="form-group row"> <label class="col-xs-12 col-md-4">Website</label> <div class="col-xs-12 col-md-8"> <input type="text" name="website" value="" class="form-control"> </div> </div> </div> </div> <div if="{regtype==\'student\'}"> <hr class="hrleft"> <h4>Director / Head of the Department</h4> <div class="row"> <div class="col-xs-12 col-md-6"> <div class="form-group row"> <label class="col-xs-12 col-md-4">Name</label> <div class="col-xs-12 col-md-8"> <input type="text" name="director_firstname" value="" class="form-control"> </div> </div> </div> <div class="col-xs-12 col-md-6"> <div class="form-group row"> <label class="col-xs-12 col-md-4">Surname</label> <div class="col-xs-12 col-md-8"> <input type="text" name="director_surname" value="" class="form-control"> </div> </div> </div> </div> </div> <div class="pull-right"><small><sup>*</sup> indicates a required field</small></div> <hr class="hrleft"> <div class="row"> <div class="col-xs-12 col-sm-6"> <button onclick="{changetype}" class="btn btn-primary changetype"><i class="fa fa-angle-left"></i>Change membership type</button> </div> <div class="col-xs-12 col-sm-6 text-right"> <confirm placement="bottom" onconfirm="{resetform}" confirmtext="Reset" class="btn btn-default formbutton">Reset</confirm> <button type="submit" __disabled="{disableregister}" class="btn btn-primary formbutton">Register<span show="{submitting}">&nbsp;<i show="{submitting}" class="fa fa-spinner fa-pulse"></i></span></button> </div> </div> </form> <div if="{signup_error}" class="alert alert-danger">{signup_error}</div> <div if="{signup_message}" class="alert alert-success">{signup_message}</div> </div>', '.btn-primary[disabled] { background: rgba(0,0,0,0.1); } .error { border-color: #fc2d21; background: rgba(252,45,33,0.05); position: relative; } .error:after { content: "!"; color: #fc2d21; position: absolute; right: 10px; } .error.emailerror { padding: 5px 10px; font-size: 14px; font-size: 1.4rem; } h1, h2, h3, h4 { text-transform: uppercase; } .hrleft { margin: 20px 0; } button.changetype { margin-bottom: 15px; } button.changetype i { margin-right: 15px; font-size: 20px; font-size: 2rem; } .memberblock { background: #fff; -webkit-box-shadow: 0 15px 15px rgba(0,0,0,0.1); box-shadow: 0 15px 15px rgba(0,0,0,0.1); padding: 30px; margin-bottom: 30px; } .memberblock h4 { text-transform: capitalize; } .memberblock:hover { cursor: pointer; background: #fc2d21; } .memberblock:hover h4 { color: #fff; } @media (max-width: 767px) { .formbutton, button.changetype { display: block; width: 100%; margin-bottom: 15px; } }', '', function(opts) {
var api, resource;

resource = require('riot-kit/utils/apiResource.coffee');

api = new resource('/duocms/api/artists/byemail', true);

this.membertypes = ["professional", "associate", "student"];

this.groups = {
  "professional": 6,
  "associate": 7,
  "student": 8
};

this.csrf = window.csrf;

this.showform = false;

this.prefixSelected = "";

this.submitting = false;

this.disableregister = true;

this.emailerror = false;

this.on('mount', (function(_this) {
  return function() {
    return console.log("registration");
  };
})(this));

window.onpopstate = (function(_this) {
  return function(e) {
    if (!e.state && _this.regtype) {
      _this.regtype = false;
      _this.showform = false;
      return _this.update();
    }
  };
})(this);

this.checkemail = (function(_this) {
  return function(e) {
    var email, isemail, re;
    if (e.srcElement) {
      email = e.srcElement.value;
    } else if (e.value) {
      email = e.value;
    }
    if (email.length > 0) {
      re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      isemail = re.test(String(email).toLowerCase());
    }
    if (isemail) {
      api.get({
        email: email
      }, function(data) {
        if (data[0] && data[0].id) {
          _this.disableregister = true;
          _this.emailerror = true;
          console.log("email exists", _this.emailerror);
        } else {
          _this.disableregister = false;
          _this.emailerror = false;
        }
        return _this.update();
      });
    } else {
      _this.disableregister = true;
    }
    return _this.update();
  };
})(this);

this.resetform = (function(_this) {
  return function() {
    _this.regform.reset();
    return _this.update();
  };
})(this);

this.choosetype = (function(_this) {
  return function(e) {
    var state;
    if (e.item.member) {
      state = {
        regform: true
      };
      window.history.pushState(state, "reg form", "/membership/");
      _this.showform = true;
      return _this.regtype = e.item.member;
    }
  };
})(this);

this.changetype = (function(_this) {
  return function() {
    _this.showform = false;
    return _this.regtype = false;
  };
})(this);

this.handleUpdatePrefix = (function(_this) {
  return function(e) {
    if (e.srcElement.checked = true) {
      _this.prefixSelected = e.srcElement.value;
    }
    return _this.update();
  };
})(this);

this.register = (function(_this) {
  return function(e) {
    var data, def_organisation, def_phone2, def_prefix, def_school, def_title, def_website, director;
    e.preventDefault();
    _this.checkemail(_this.email);
    _this.signup_error = null;
    if (_this.director_firstname) {
      director = _this.director_firstname + " " + _this.director_surname;
    } else {
      director = "";
    }
    def_prefix = _this.prefixSelected || "";
    def_title = _this.title.value || "";
    def_school = _this.school.value || "";
    def_organisation = _this.organisation.value || "";
    def_phone2 = _this.phone2.value || "";
    def_website = _this.website.value || "";
    data = {
      username: _this.email.value,
      first_name: _this.first_name.value,
      surname: _this.surname.value,
      prefix: def_prefix,
      title: def_title,
      designation: _this.designation.value,
      organisation: def_organisation,
      school: def_school,
      address: _this.address.value,
      city: _this.city.value,
      state: _this.state.value,
      postcode: _this.postcode.value,
      country: _this.country.value,
      phone1: _this.phone1.value,
      phone2: def_phone2,
      fax: _this.fax.value,
      email: _this.email.value,
      website: def_website,
      membertype: _this.regtype,
      groups: _this.groups[_this.regtype]
    };
    if (data) {
      _this.submitting = true;
      return _this.xhr("POST", "/duocms/api/register", data, function(res) {
        var message, ref;
        if (res.status === 200) {
          _this.showform = false;
          message = "You should have received an email from us. Click on the link in that email to activate your account.";
          _this.signup_message = message;
        } else if ((ref = res.body) != null ? ref.message : void 0) {
          _this.signup_error = res.body.message;
          setTimeout((function() {
            return _this.signup_error = null;
          }), 3000);
        } else {
          _this.signup_error = "Signup failed, please try again";
          setTimeout((function() {
            return _this.signup_error = null;
          }), 3000);
        }
        _this.submitting = false;
        return _this.update();
      });
    } else {
      _this.signup_error = "You have not completed all required fields";
      setTimeout((function() {
        return _this.signup_error = null;
      }), 3000);
      return _this.update();
    }
  };
})(this);

this.xhr = (function(_this) {
  return function(method, url, data, cback) {
    var xhr;
    xhr = new XMLHttpRequest();
    xhr.open(method, url, true);
    xhr.setRequestHeader("Content-type", "application/json");
    xhr.setRequestHeader("x-csrf-token", window.csrf);
    xhr.onreadystatechange = function() {
      var res;
      if (xhr.readyState === 4) {
        try {
          res = JSON.parse(xhr.responseText);
        } catch (error) {
          res = "";
        }
        return cback({
          status: xhr.status,
          body: res
        });
      }
    };
    return xhr.send(JSON.stringify(data));
  };
})(this);
});
    
  